export const NotFound = () => {
  return <div>Page not found</div>;
};
